import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import HomePage from "../components/HomePage";

const Home = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <HomePage />
    </Layout>
  );
};
export default Home;
